import { render, staticRenderFns } from "./AssociarProdutoFornecedor.vue?vue&type=template&id=3f2f33d9&scoped=true"
import script from "./AssociarProdutoFornecedor.vue?vue&type=script&lang=js"
export * from "./AssociarProdutoFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2f33d9",
  null
  
)

export default component.exports